import { Helmet } from 'react-helmet-async';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { Link } from 'react-router-dom';

const FacultyDevelopmentProgram = () => {

    return (
        <section>
            <div className='about-mijsc-section w-full bg-cover h-fit pb-5'>
                <Helmet>
                    <title>LMP Faculty Development Program </title>
                    <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
                </Helmet>
                <section className='bg-gray-200 w-full py-2 h-[70px]'>
                    <div className='text-sm flex items-center gap-2 py-3 place-content-center'>
                        <Link to="/" className="hover:text-green-600 font-semibold">Home</Link>
                        <MdKeyboardDoubleArrowRight className='text-green-600' />
                        <Link to="/" className="hover:text-green-600 font-semibold">MIJSC Programs</Link>
                        <MdKeyboardDoubleArrowRight className='text-green-600' />
                        <Link to="/" className="hover:text-green-600 font-semibold">LMP Faculty Development Program</Link>
                    </div>
                </section>
                <div className="mx-5 md-mx-10 my-5">
                    <div className="w-full my-5 lg:text-justify text-left flex flex-col md:flex-row gap-6 pt-10">
                        <section className="md:w-1/2 h-full md:pr-5">
                            <h1 className='mb-8 text-green-600 md:text-4xl text-2xl font-semibold uppercase'>LMP Faculty Development <br />Program</h1>

                            <h2 className="md:text-xl text-lg text-green-600 font-semibold">
                                Phase -1
                            </h2>
                            <p class="mt-3 text-gray-700"><i class='bx bxs-arrow-to-right'></i><b> Facilitator :</b> MIJSC @ IIMB </p>
                            <p className='text-gray-700'><i class='bx bxs-arrow-to-right'></i><b> Timeline:</b> 6 months</p>
                            <p className='text-gray-700'><i class='bx bxs-arrow-to-right'></i><b> Mode of Delivery :</b> Self Learning (MOOCs) + Expert Interventions (Online) + Immersive Learning @ IIMB (Offline) + Industry Project (Offline)</p>
                            <p className='text-gray-700'><i class='bx bxs-arrow-to-right'></i><b> Outcome :</b> Engineering College Faculty as Experts in Lean Principles.</p>
                            <p className='text-gray-700'><i class='bx bxs-arrow-to-right'></i><b> Key Benefits:</b> Faculty developed as Lean experts.</p>
                            <p className='md:text-md mt-5 text-gray-700'>The LMP course, under the Faculty Development Program, is planned for delivery over 9 months with Self learning through MOOCs (Massive Open Online Courses) platform and regular online Module Director interventions by industry experts.</p>
                        </section>
                        <section className="md:w-1/2 h-fit md:pl-5">
                            <img
                                src="/assets/imgs/faculty-development.jpg"
                                alt="Phase 1"
                                className="md:w-full  md:object-contain rounded-xl w-full h-auto"
                            />
                        </section>
                    </div>

                    <section className="overflow-x-auto my-10 ">
                        <table className="w-full border border-gray-300 text-sm text-left">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th
                                        rowSpan="2"
                                        className="border border-gray-300 px-4 py-3 font-semibold"
                                    >
                                        Course
                                    </th>
                                    <th
                                        rowSpan="2"
                                        className="border border-gray-300 px-4 py-3 font-semibold"
                                    >
                                        Content
                                    </th>
                                    <th
                                        colSpan="9"
                                        className="border border-gray-300 px-4 py-3 text-center font-semibold"
                                    >
                                        Months
                                    </th>
                                </tr>
                                <tr className="bg-gray-50 text-center">
                                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((month) => (
                                        <th
                                            key={month}
                                            className="border border-gray-300 px-3 py-2 font-medium"
                                        >
                                            {month}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {/* Foundations of Lean Manufacturing Practices */}
                                <tr>
                                    <td className="border border-gray-300 px-4 py-3 font-medium">
                                        Foundations of Lean Manufacturing Practices
                                    </td>
                                    <td className="border border-gray-300 px-4 py-3">
                                        6 Modules of Self Learning + Industry Expert Interventions + Industry Application Projects
                                    </td>

                                    {/* Months 1–5 shaded */}
                                    {[1, 2, 3, 4, 5].map((m) => (
                                        <td
                                            key={m}
                                            className="border border-gray-300 bg-green-700"
                                        ></td>
                                    ))}

                                    {/* Months 6–9 empty */}
                                    {[6, 7, 8, 9].map((m) => (
                                        <td key={m} className="border border-gray-300"></td>
                                    ))}
                                </tr>

                                {/* Advanced Lean Manufacturing Practices */}
                                <tr>
                                    <td className="border border-gray-300 px-4 py-3 font-medium">
                                        Advanced Lean Manufacturing Practices
                                    </td>
                                    <td className="border border-gray-300 px-4 py-3">
                                        6 Modules of Self Learning + Industry Expert Interventions + Industry Application Projects
                                    </td>

                                    {/* Months 1–4 empty */}
                                    {[1, 2, 3, 4].map((m) => (
                                        <td key={m} className="border border-gray-300"></td>
                                    ))}

                                    {/* Months 5–9 shaded */}
                                    {[5, 6, 7, 8, 9].map((m) => (
                                        <td
                                            key={m}
                                            className="border border-gray-300 bg-green-700"
                                        ></td>
                                    ))}
                                </tr>
                            </tbody>
                        </table>
                    </section>
                </div>
            </div>
        </section>
    )
}

export default FacultyDevelopmentProgram
